import { BaseHistoryElement } from '../BaseHistoryElement';

export class AuxiliaryHistoryElement extends BaseHistoryElement {
  constructor() {
    super();
  }
}
